import NewsletterManagement from './NewsletterManagement';
export default NewsletterManagement;
